module.exports = __webpack_public_path__ + "img/cosmetica.00e08d67.jpg";